export default [
  {
    title: 'Benvenuto',
    element: 'body',
    text: 'Benvenuto in Idónea, la tua piattaforma di scambio di immagini mediche. In questo tour ti aiuteremo a iniziare ad usarlo.'
  },
  {
    title: 'La mia area',
    element: '.idonia-header .toolbar__title',
    text: 'In "La mia area" puoi vedere tutte le cartelle, i documenti e gli studi che hai in Idonia. Trascina qui le cartelle o i file che desideri archiviare in Idonia.'
  },
  {
    title: 'Pulsante "+"',
    element: '.action-fab button',
    text: 'Utilizza questo menu per creare una cartella di contenuti, caricare un file o cartelle sul dispositivo. Puoi anche caricare un intero studio DICOM per visualizzarlo.',
    clickNext: 'nav button',
    wait: 150,
    placement: {
      relativeTo: 'viewport',
      position: 'top'
    }
  },
  {
    title: 'File condivisi',
    element: 'a[data-name="shared"]',
    text: 'In "condiviso con me" vedrai i file e le cartelle condivisi da altri utenti.',
    clickBack: 'nav button',
    wait: 150
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/it-IT/regular.js